<div class="modal-header">
    <h4 class="modal-title">Add Client Secret</h4>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form autocomplete="off" #clientSecretForm="ngForm">

        <div class="form-group">
            <label for="description">Description</label>
            <input type="text" class="form-control" #description="ngModel" [(ngModel)]="clientSecret.description"
                name="description">
        </div>

        <div class="form-group">
            <label for="secret">Secret</label>
            <input type="text" class="form-control" #secret="ngModel" [(ngModel)]="clientSecret.secret" minlength="20"
                maxlength="100" required name="secret">
            <div *ngIf="!secret.valid && secret.touched" class="alert alert-danger">
                <div *ngIf="secret.errors.required">
                    Secret is required.
                </div>
                <div *ngIf="secret.errors.minlength">
                    Secret must be at least 20 characters long.
                </div>
                <div *ngIf="secret.errors.maxlength">
                    Secret must be less than 100 characters long.
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="expiresAt">Expires At (local time)</label>
            <div class="input-group">
                <input class="form-control" placeholder="yyyy-mm-dd" name="expiresAt"
                    [(ngModel)]="expiresAt" ngbDatepicker #d="ngbDatepicker">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button"><i class="fas fa-calendar"></i></button>
                </div>
            </div>
        </div>

    </form>

    <div class="clearfix mt-5">
        <button class="btn btn-primary btn float-right" [disabled]="!clientSecretForm.valid" (click)="add()">Add</button>
        <button class="btn btn-secondary btn float-right mr-1" (click)="cancel()">Cancel</button>
    </div>
</div>